/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import {webApi} from '../../../lib/WebApi'

export const LOAD_DIVISIONS_STARTED = 'LOAD_DIVISIONS_STARTED'
export function loadDivisionsStarted() {
    return {
        type: LOAD_DIVISIONS_STARTED,
    }
}

export const LOAD_DIVISIONS_SUCCEEDED = 'LOAD_DIVISIONS_SUCCEEDED'
export function loadDivisionsSucceeded(divisions, teams) {
    if(teams) {
        for (let i in divisions) {
            let item = divisions[i]
            item.teams = teams[i].data
        }
    }
    divisions.sort((obj1, obj2) => obj1.title.localeCompare(obj2.title))
    return {
        type: LOAD_DIVISIONS_SUCCEEDED,
        divisions: divisions
    }
}

export const LOAD_DIVISIONS_FAILED = 'LOAD_DIVISIONS_FAILED'
export function loadDivisionsFailed() {
    return {
        type: LOAD_DIVISIONS_FAILED,
    }
}

export function loadDivisions() {
    return function(dispatch) {
        dispatch(loadDivisionsStarted())
        dispatch(loadDivisionsRequest((err, divisions) => {
            if (err) {
                dispatch(loadDivisionsFailed())
            } else {
                dispatch(loadDivisionsSucceeded(divisions))
            }
        }))
    }
}

export function loadDivisionsAndTeams() {
    return function(dispatch) {
        dispatch(loadDivisionsStarted())
        dispatch(loadDivisionsAndTeamsRequest((err, divisions, teams) => {
            if (err) {
                dispatch(loadDivisionsFailed())
            } else {
                dispatch(loadDivisionsSucceeded(divisions, teams))
            }
        }))
    }
}

export function loadDivisionsRequest(callback) {
    return (dispatch) => {
        return webApi.getUserDivisions()
            .then(divisions => callback(null, divisions), error => callback(new Error(error)))
            .catch(err => callback(err))
    }
}

export function loadDivisionsAndTeamsRequest(callback) {
    return (dispatch) => {
        return webApi.getUserDivisions()
            .then((divisions) => {
                const ids = divisions.map((item) => item.division_id)
                webApi.batchGetDivisionsTeams(ids)
                    .then((teams) => callback(null, divisions, teams), error => callback(null, divisions))
            }, error => callback(new Error(error))
            )
            .catch(err => callback(err))
    }
}

export function loadDivisionBilling(divId) {
    return new Promise((resolve, reject) => {
        webApi._get(`/webapp/divisions/${divId}/billing`)
            .then(json => {
                console.log('loadBilling', divId, json)
                resolve(json)
            })
            .catch(e => {
                console.log('LoadDivisionBilling error', e)
                resolve(null)
            })
    })
}
